import React, { memo } from 'react';
import { Typography, Grid, Pagination } from '@mui/material';
import { useGlobalContext } from 'Context/GlobalContext';
import { useCedulasContext } from "Context/CedulasPageContext";

const PaginationFinder = memo(() => {
    const { responsiveScreen } = useGlobalContext();
    const { cedulasData, filterPage, handlePageChange } = useCedulasContext();

    return (
        <Grid container sx={{ width: '100%' }}>
            <Grid item xs={12} md={6}>
                <Typography 
                    sx={{ 
                        alignItems: 'center', 
                        justifyContent: responsiveScreen ? 'center' : 'start',
                        display: 'flex',
                        color: '#3B4348', 
                        fontSize: '15px', 
                        height: '100%',
                        ml: responsiveScreen ? 0 : 5
                    }}
                >
                    {`*Búsqueda ordenada por fecha de desaparición`}
                </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
                <Pagination 
                    count={cedulasData.totalPages} 
                    page={filterPage}
                    onChange={handlePageChange} 
                    size={responsiveScreen ? "medium" : "large"} 
                    color="primary" 
                    sx={{
                        button:{color: '#5A7C72'}, 
                        justifyContent: responsiveScreen ? 'center' : 'end', 
                        display: 'flex',
                        my: 2,
                        mr: responsiveScreen ? 0 : 8,
                        "& .MuiPagination-ul": {
                            flexWrap: 'nowrap',
                        },
                    }}
                />
            </Grid>
        </Grid>
    )
})

export default PaginationFinder;